export default __webpack_public_path__ + "static/media/slide7.45f0fe58.jpg";